import { motion } from 'framer-motion';

export default function AppCard({ app, index = 0 }) {
  return (
    <motion.a
      href={app.appStoreUrl}
      target="_blank"
      rel="noopener noreferrer"
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ delay: (index % 6) * 0.06, duration: 0.5 }}
      whileHover={{ y: -4 }}
      className="group relative flex flex-col overflow-hidden rounded-[24px] glass hover:bg-white/[0.08] transition duration-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-sky-500/60"
      aria-label={`View details or download ${app.name}`}
    >
      <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition duration-500 pointer-events-none" style={{ background: 'radial-gradient(500px circle at 50% 0%, rgba(14,165,233,0.12), transparent 70%)' }} />
      {app.badge && (
        <div className="absolute top-4 right-4 z-10 rounded-full bg-white text-black text-[11px] font-bold tracking-widest px-2.5 py-1 shadow-lg">{app.badge}</div>
      )}
      <div className="relative p-6 flex items-center gap-4">
        <div className="relative shrink-0">
          <div className="absolute inset-0 rounded-2xl blur-[12px] opacity-40 bg-gradient-to-br from-sky-500 to-blue-600 group-hover:opacity-60 transition" />
          <img src={app.icon} alt={app.name + ' icon'} className="relative w-[64px] h-[64px] rounded-2xl border border-white/10 shadow-lg object-cover" loading="lazy" />
        </div>
        <div>
          <h3 className="text-[17px] font-semibold tracking-tight text-white group-hover:text-white transition">{app.name}</h3>
          <p className="text-[11px] font-medium uppercase tracking-[0.14em] text-white/40 mt-0.5">{app.category}</p>
          {app.microcopy && <p className="text-[13px] text-white/60 mt-1 leading-5">{app.microcopy}</p>}
        </div>
      </div>
      <div className="relative px-6 pb-3">
        <p className="text-[13.5px] leading-6 text-white/50 line-clamp-2">{app.description}</p>
      </div>
      {app.screenshots && (
        <div className="relative pl-6 pr-0 pb-5">
          <div className="flex gap-3 overflow-x-auto pb-2 snap-x snap-mandatory scrollbar-hide pr-6 -mr-6">
            {app.screenshots.map((src, idx) => (
              <img
                key={idx}
                src={src}
                alt={app.name + ' screenshot ' + (idx + 1)}
                className="h-[168px] w-auto object-contain rounded-xl border border-white/10 bg-black/30 shadow-sm snap-center shrink-0"
                style={{ minWidth: 96 }}
                loading="lazy"
              />
            ))}
          </div>
        </div>
      )}
      <div className="relative mt-auto px-6 py-4 border-t border-white/10 bg-white/[0.02] flex items-center justify-between">
        <span className="text-xs font-medium text-white/60 group-hover:text-white transition flex items-center gap-1.5">App Store <span className="group-hover:translate-x-0.5 transition">→</span></span>
        <img src="/apps/app-store-badge.svg" alt="Download on the App Store" className="h-8 w-auto opacity-90 group-hover:opacity-100 transition" />
      </div>
    </motion.a>
  );
}
